/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { ActionsObservable, StateObservable } from 'redux-observable';
import { isOfType } from 'typesafe-actions';
import { filter, map, mergeMap } from 'rxjs/operators';
import { catchError } from 'rxjs/internal/operators/catchError';
import { from, of } from 'rxjs';

import {
  deleteDesignSuccess,
  deleteDesignFailure,
  DeleteDesignAction,
  DeleteDesignActionTypes,
} from '../actions/DeleteDesign';
import { IErrorActionData } from '../../../models/Error';
import RootState from '../../../config/store/RootState';
import RootAction from '../../../config/store/RootAction';
import deleteDesignService from '../services/DeleteDesign';

const DeleteDesignEpic = (action$: ActionsObservable<RootAction>, state$: StateObservable<RootState>) => action$.pipe(
  filter(isOfType(DeleteDesignActionTypes.DELETE_KITCHEN)),
  mergeMap((action: DeleteDesignAction) => from(
    deleteDesignService(action.payload),
  ).pipe(
    map((response) => deleteDesignSuccess()),
    catchError((error: any) => of(
      deleteDesignFailure({
        errorCode: error.errorCode || 500,
        errorMessage: error.errorMessage,
        callBack: error.callBack,
      }),
    )),
  )),
);

export default DeleteDesignEpic;
